import { Link } from 'react-router-dom';
import { KeyRound, Check, Settings as SettingsIcon, AlertCircle } from 'lucide-react';
import { Card, CardTitle, Button } from '@/components/ui';

/**
 * API 키가 필요한 페이지의 공용 게이트.
 * - 키 없음 → 큰 경고 카드 + "설정으로 이동" 버튼 (children 폼은 disabled 상태로 자식이 처리)
 * - 키 있음 → 작은 인디케이터 박스 (변경하려면 설정으로)
 *
 * 페이지 form 의 canSubmit 에 prefs.geminiApiKey 비어있지 않은지 함께 체크하면 됩니다.
 */
export function ApiKeyGate({ hasKey }: { hasKey: boolean }) {
  if (!hasKey) {
    return (
      <Card className="border-red-500/40 bg-red-500/5">
        <CardTitle className="flex items-center gap-2 text-red-200">
          <AlertCircle className="h-5 w-5" /> Gemini API 키가 필요합니다
        </CardTitle>
        <p className="mt-2 text-sm text-gray-300">
          이 기능은 사용자 본인의 Google Gemini 키를 사용합니다. 키는 <strong>설정 페이지</strong>에서
          한 번 저장하면 이 브라우저에 안전하게 보관되어 모든 AI 기능이 자동으로 사용합니다.
          서버에는 절대 저장되지 않습니다.
        </p>
        <div className="mt-4 flex flex-wrap items-center gap-2">
          <Link to="/settings">
            <Button variant="gold">
              <SettingsIcon className="h-4 w-4" /> 설정에서 키 저장하기
            </Button>
          </Link>
          <a
            href="https://aistudio.google.com/apikey"
            target="_blank"
            rel="noreferrer"
            className="text-xs text-gold hover:underline"
          >
            Gemini 키 발급받기 →
          </a>
        </div>
        <p className="mt-3 text-[11px] text-gray-500">
          무료 quota 일 1,500회. 한 번 발급해두면 블로그코치 · 1page 분석 · 경쟁 격차 전부 사용 가능.
        </p>
      </Card>
    );
  }

  return (
    <div className="inline-flex items-center gap-2 rounded-lg border border-emerald-400/40 bg-emerald-400/5 px-3 py-1.5 text-xs text-emerald-200">
      <Check className="h-3.5 w-3.5" />
      <KeyRound className="h-3.5 w-3.5" />
      <span className="font-medium">설정에 저장된 Gemini 키 사용 중</span>
      <Link to="/settings" className="text-gold hover:underline ml-1">
        변경
      </Link>
    </div>
  );
}
